import styled, { css } from 'styled-components';
import { Button } from 'antd';

export const CustomLabel = styled.label`
	font-size: ${({ theme }) => theme.fonts.label.md.fontSize} !important;
	line-height: ${({ theme }) => theme.fonts.label.md.lineHeight} !important;
	font-weight: ${({ theme }) => theme.fonts.label.md.fontWeight} !important;
	letter-spacing: ${({ theme }) => theme.fonts.label.md.letterSpacing} !important;
	color: ${({ theme }) => theme.colors.text} !important;
	margin-bottom: 16px;
	display: block;
`;

export const CustomButton = styled(Button)`
	align-items: center;
	border-radius: 12px;
	display: flex;
	height: 80px;
	justify-content: space-between;
	width: 100%;
	padding: 0 20px;

	&:hover,
	&:focus {
		h4,
		p {
			color: ${({ theme }) => theme.colors.text};
		}
	}
`;

export const CustomContainerTooltip = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;

	.content-tool {
		text-align: left;
		margin-left: 20px;

		h4 {
			${({ theme }) => css`
				${{ ...theme.fonts.label.md }}
			`}
		}

		p {
			${({ theme }) => css`
				${{ ...theme.fonts.body.sm }}
			`}
			margin: 0;
		}
	}
`;

export const LibertyMutualRisks = styled.div`
	width: 50px;
	padding: 4px 0px;
	border: 1px solid rgb(47, 84, 235);
	background-color: rgb(234, 238, 253);
`;
